import { IconButton } from '@fluentui/react/lib/Button';
import { IPanel, Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Persona, PersonaPresence, PersonaSize } from '@fluentui/react/lib/Persona';
import { Toggle } from '@fluentui/react/lib/Toggle';
import * as React from 'react';
import { logout, User } from '../../api/AuthProvider';
import { getPhoto } from '../../api/GraphProvider';
import { useGlobalState } from '../../service/globalState.service';
import { setDarkTheme, setShowAllTasks, setPendingCategory } from '../../service/settingsState.service';

const { useEffect, useState } = React;

interface HeaderProps {
  user: User;
}

export const Header: React.FC<HeaderProps> = ({ user }) => {
  const [avatar, setAvatar] = useState<string>();
  const [isOpen, setOpen] = useState(false);
  const [{ darkTheme, pendingCategory, showAllTasks }] = useGlobalState('settings');
  const panelRef = React.createRef<IPanel>();

  useEffect(() => {
    requestPhoto();
  }, []);

  const requestPhoto = async () => {
    const res = await getPhoto();
    const imageBlob = await res.blob();
    const imageObjectURL = URL.createObjectURL(imageBlob);
    setAvatar(imageObjectURL);
  }

  const toggleOpen = () => setOpen(!isOpen);

  const openFeedbackSite = () => window.open('https://forms.office.com/r/PUafMFKZWk', '_blank');

  const workaround = () => {
    const container = document.querySelector('.ms-Panel-scrollableContent');
    container['style'].background = 'inherit';
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}>
      <Persona
        text={user.email}
        presence={PersonaPresence.online}
        size={PersonaSize.size32}
        imageUrl={avatar}
      />

      <Panel
        componentRef={panelRef}
        type={PanelType.smallFluid}
        onDismiss={toggleOpen}
        headerText="Settings"
      >
        <Persona
          presence={PersonaPresence.none}
          size={PersonaSize.size40}
          imageUrl={avatar}
          text={user.name}
          secondaryText={user.email}
        />

        <br />

        <Toggle
          label="Change theme"
          onText="Dark mode"
          offText="Light mode"
          checked={darkTheme}
          onChange={(e, c) => {
            workaround();
            setDarkTheme(c)
          }}
        />
        <Toggle
          label="Pending Allocatus category"
          onText=""
          offText=""
          checked={pendingCategory}
          onChange={(e, c) => {
            workaround();
            setPendingCategory(c)
          }}
        />
        <Toggle
          label="Show all tasks in list"
          onText=""
          offText=""
          checked={showAllTasks}
          onChange={(e, c) => {
            workaround();
            setShowAllTasks(c)
            setTimeout(() => location.reload(), 300);
          }}
        />
      </Panel>

      <IconButton iconProps={{ iconName: 'CollapseMenu' }} menuProps={{
        items: [
          {
            key: 'settings',
            iconProps: { iconName: 'Settings' },
            text: 'Settings',
            onClick: () => panelRef.current.open()
          },
          {
            key: 'feedback',
            iconProps: { iconName: 'Feedback' },
            text: 'Give feedback',
            onClick: openFeedbackSite
          },
          {
            key: 'logout',
            iconProps: { iconName: 'SignOut' },
            text: 'Log out',
            onClick: logout
          }
        ]
      }} />
    </div>
  )
}